export const ROW_NUMBERS_COLUMN_ID = "Row_Numbers_Column";
export const ROW_NUMBERS_COLUMN_MIN_WIDTH = 50;
export const ROW_NUMBERS_COLUMN_INITIAL_WIDTH = 50;
